import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { UitkCardAloha, UitkCardAlohaContentSection } from 'uitk-react-cards';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';

import { AlternateDatesFragment } from 'src/common/__generated__/api';

const LinkTracked = ClickTracker(Link);

export interface AlternateDatesCardProps {
  className?: string;
  model: AlternateDatesFragment.Fragment;
}

export const AlternateDatesCard: React.FunctionComponent<AlternateDatesCardProps> = ({ className, model }) => {
  if (!model || !model.options || model.options.length < 1) {
    return null;
  }

  const { header, options } = model;

  return (
    <UitkCardAloha className={className}>
      <UitkCardAlohaContentSection>
        {header.text && (
          <UitkHeading level={3} size={400} data-stid="alternate-dates-heading">
            {header.text}
          </UitkHeading>
        )}
        {header.subText && (
          <UitkText size={200} data-stid="alternate-dates-subheading">
            {header.subText}
          </UitkText>
        )}
      </UitkCardAlohaContentSection>
      <UitkCardAlohaContentSection>
        <UitkLayoutGrid columns={{ small: 1, medium: 2, large: 3 }} space="four">
          <>
            {options.map((option, index) => (
              <UitkLayoutGridItem key={`alternate-date-option-${index}`}>
                <UitkLayoutFlex space="six">
                  <>
                    <UitkLayoutFlexItem>
                      <LinkTracked
                        to={option.dates.link.uri.relativePath}
                        inline={true}
                        replace={false}
                        rfrr={`AlternateDates.SoldOut${index + 1}`}
                        linkName="Alternate Dates Selection"
                      >
                        {option.dates.value}
                      </LinkTracked>
                    </UitkLayoutFlexItem>

                    {option.price?.displayPrice && (
                      <UitkLayoutFlexItem>
                        <UitkText>{option.price.displayPrice.formatted}</UitkText>
                      </UitkLayoutFlexItem>
                    )}
                  </>
                </UitkLayoutFlex>
              </UitkLayoutGridItem>
            ))}
          </>
        </UitkLayoutGrid>
      </UitkCardAlohaContentSection>
    </UitkCardAloha>
  );
};

AlternateDatesCard.displayName = 'AlternateDatesCard';
